import src from "IMAGE";
export default { src, width: 188, height: 167, blurWidth: 0, blurHeight: 0};
